module.exports = __webpack_public_path__ + "img/1.7668aa16.jpg";